<template>
  <profile-section
    :section-title="'Profile'"
  >
    <name-subsection
      :active-section="activeSection"
      :submitting="submitting"
      :user="user"
      @clear-active="$emit('clear-active')"
      @set-active="$emit('set-active', 'Name')"
      @set-submitting="setSubmitting"
    />
    <password-subsection
      :active-section="activeSection"
      :submitting="submitting"
      @clear-active="$emit('clear-active')"
      @set-active="$emit('set-active', 'Password')"
      @set-submitting="setSubmitting"
    />
    <phone-subsection
      v-if="showPhoneSubsection"
      :active-section="activeSection"
      :submitting="submitting"
      :user="user"
      @clear-active="$emit('clear-active')"
      @set-active="$emit('set-active', 'Phone')"
      @set-submitting="setSubmitting"
    />
    <study-goal-subsection
      v-if="studyGoal"
      :active-section="activeSection"
      :config="studyGoal"
      :submitting="submitting"
      @clear-active="$emit('clear-active')"
      @set-active="$emit('set-active', 'Study Goal')"
      @set-submitting="setSubmitting"
    />
  </profile-section>
</template>

<script>
import ProfileSection from '@components/profile/section';

import NameSubsection from '@components/profile/widgets/mastery/subsections/name';
import PasswordSubsection from '@components/profile/widgets/mastery/subsections/password';
import PhoneSubsection from '@components/profile/widgets/mastery/subsections/phone';
import StudyGoalSubsection from '@components/profile/widgets/mastery/subsections/study-goal';

export default {
  components: { NameSubsection, PasswordSubsection, PhoneSubsection, ProfileSection, StudyGoalSubsection },
  props: {
    activeSection: {
      type: String,
      default: null,
    },
    subscriptionReceipt: {
      type: Object,
    },
  },
  emits: ['clear-active', 'set-active'],
  data() {
    return {
      submitting: null,
    };
  },
  computed: {
    showPhoneSubsection() {
      const pv = this.$store.getters['productVars/get']['showPhoneNumber'];
      return pv && pv.value === 'true';
    },
    studyGoal() {
      const user = this.$store.getters['session/currentUser'];
      return (this.$store.getters['userProfileConfigs/get'][user.classificationId] || []).find(config => config.userProfileColumnName === 'studyGoal');
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
  },
  methods: {
    setSubmitting(val) {
      this.submitting = val;
    },
  },
};
</script>
